import { fetchCaseIntakes, fetchCaseSectionValues } from "redux/slices/case";
import useAppDispatchWithSnackbar from "./useAppDispatchWithSnackbar";
import { useAppDispatch } from "redux/hooks";

export function useCase(caseId: number) {
  const snackpatch = useAppDispatchWithSnackbar();
  const dispatch = useAppDispatch();

  async function onDocumentsUpload() {
    return await Promise.all([
      snackpatch(fetchCaseIntakes({ caseId, forceRefresh: true }), {
        errorMessage: "There was a problem loading the case documents. Please try again later.",
      }),
      dispatch(fetchCaseSectionValues({ caseId })),
    ]);
  }

  return {
    onDocumentsUpload,
  };
}
